import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MenuIcon from '@mui/icons-material/Menu';

import PrimaryButton from '../buttons/primary-button';
import Logo from './images/logo@2x.png';

const ButtonLink = forwardRef((props, ref) => (
    <NavLink ref={ref} {...props} />
));

const NavButtons = ({ isMobile }) => (
    <>
        <Button
            color="secondary"
            to="/about"
            component={ButtonLink}
            sx={{
                ml: 6,
            }}
        >
            About
        </Button>
        <Button
            color="secondary"
            to="/demo"
            component={ButtonLink}
            sx={{
                ml: 6,
            }}
        >
            Contact Us
        </Button>
        {isMobile && (
            <Button
                color="primary"
                to="/demo"
                component={ButtonLink}
                sx={{
                    ml: 6,
                }}
            >
                Request Demo
            </Button>
        )}
    </>
);

NavButtons.defaultProps = {
    isMobile: false,
};

NavButtons.propTypes = {
    isMobile: PropTypes.bool,
};

const MobileHeader = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const toggleDrawer = () => (event) => {
        if (
            event
            && event.type === 'keydown'
            && (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setDrawerOpen(true);
    };

    return (
        <>
            <IconButton onClick={toggleDrawer()} style={{ marginLeft: 30 }}><MenuIcon fontSize="large" /></IconButton>
            <SwipeableDrawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                onOpen={() => setDrawerOpen(true)}
            >
                <Box
                    sx={{
                        width: 250,
                        height: '100vh',
                    }}
                    role="presentation"
                    onClick={() => setDrawerOpen(false)}
                    onKeyDown={() => setDrawerOpen(false)}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'end',
                        }}
                    >
                        <IconButton onClick={() => setDrawerOpen(false)}>
                            <CloseIcon fontSize="large" />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                        }}
                    >
                        <NavButtons isMobile />
                    </Box>
                </Box>
            </SwipeableDrawer>
        </>
    );
};

const Header = () => {
    const navigate = useNavigate();
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('tablet'), { noSsr: true });
    return (
        <Container
            component="header"
            style={{
                backgroundColor: '#FFFFFF',
                boxShadow: 'inset 0 -1px 0 0 #E7E6ED',
            }}
        >
            <Box
                sx={{
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: 65,
                    maxWidth: (theme) => theme.breakpoints.values.desktop,
                }}
            >
                <Grid item component="nav" style={{ flexGrow: 1 }}>
                    <Link to="/">
                        <img src={Logo} alt="Virtual Clinic" style={{ height: 38 }} />
                    </Link>
                    {!isMobile && <NavButtons />}
                </Grid>
                {!isMobile && (
                    <Grid item>
                        <PrimaryButton onClick={() => navigate('/demo')}>
                            Request Demo
                        </PrimaryButton>
                    </Grid>
                )}
                {isMobile && <MobileHeader isMobile />}
            </Box>
        </Container>
    );
};

export default Header;
